/*
 * QR-Code als SVG, ohne innerHTML: die Module werden zu einem Pfad, schwarz
 * auf weiss mit Ruhezone, damit jede Handykamera ihn auch im dunklen Thema
 * liest.
 */

import qrcode from 'qrcode-generator';

/** Pfad der dunklen Module, eine Einheit je Modul, versetzt um die Ruhezone. */
export function qrModules(text: string, margin = 4): { size: number; path: string } {
  const qr = qrcode(0, 'M');
  qr.addData(text, 'Byte');
  qr.make();
  const n = qr.getModuleCount();
  let path = '';
  for (let r = 0; r < n; r++) {
    for (let c = 0; c < n; c++) {
      if (qr.isDark(r, c)) path += `M${c + margin} ${r + margin}h1v1h-1z`;
    }
  }
  return { size: n + margin * 2, path };
}

export function QrCode({ text, label }: { text: string; label: string }) {
  const { size, path } = qrModules(text);
  return (
    <svg class="hv-qr" viewBox={`0 0 ${size} ${size}`} role="img" aria-label={label} shape-rendering="crispEdges">
      <rect width={size} height={size} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
}
